/**
 * Data-driven table of Okta group rules (SSWS). Full ACTIVE rule JSON is sent to idwiz AI
 * in the same turn as the Review flow (single architect request after fetch).
 */
import AutomationProgressBar from "./AutomationProgressBar.jsx";

export default function GroupRulesPanel({ view }) {
  if (!view || view.status === "idle") return null;

  const { status, rules, error, progressSteps } = view;

  return (
    <div className="mr-4 rounded-xl border border-[rgb(var(--idaxis-accent-primary-rgb)/0.2)] bg-[rgb(var(--idaxis-accent-primary-rgb)/0.04)] px-4 py-3">
      <p className="text-[10px] font-semibold uppercase tracking-widest text-[rgb(var(--idaxis-accent-primary-rgb)/0.9)]">
        Group rules (live)
      </p>
      <p className="mt-1 text-[11px] text-slate-500">
        Active membership rules from Okta (SSWS). The audit above used this same payload in one request — refresh the list with
        Review to re-fetch and re-analyze.
      </p>

      {status === "loading" && Array.isArray(progressSteps) && progressSteps.length > 0 ? (
        <AutomationProgressBar steps={progressSteps} />
      ) : status === "loading" ? (
        <div className="mt-3 flex items-center gap-2 text-xs text-slate-400">
          <span className="inline-flex h-2 w-2 animate-pulse rounded-full bg-[rgb(var(--idaxis-accent-primary-rgb)/1)]" />
          I am now fetching group rules from Okta…
        </div>
      ) : null}

      {status === "error" && error ? (
        <p className="mt-3 text-sm leading-relaxed text-rose-200/95">{error}</p>
      ) : null}

      {status === "success" && rules?.length > 0 ? (
        <div className="mt-3 max-h-56 overflow-auto rounded-lg border border-white/[0.08]">
          <table className="w-full text-left text-[12px] text-slate-200">
            <thead className="sticky top-0 border-b border-white/[0.08] bg-[#020617]/95 text-[10px] font-semibold uppercase tracking-wider text-slate-500">
              <tr>
                <th className="px-3 py-2">Name</th>
                <th className="px-3 py-2">Status</th>
                <th className="hidden px-3 py-2 sm:table-cell">Id</th>
              </tr>
            </thead>
            <tbody>
              {rules.map((r) => (
                <tr
                  key={r.id || r.name}
                  className="border-b border-white/[0.04] last:border-0 hover:bg-white/[0.03]"
                >
                  <td className="px-3 py-2 font-medium text-slate-100">{r.name}</td>
                  <td className="px-3 py-2 text-[11px] uppercase tracking-wide text-slate-400">
                    {r.status || "—"}
                  </td>
                  <td className="hidden font-mono text-[10px] text-slate-500 sm:table-cell">{r.id || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}

      {status === "success" && (!rules || rules.length === 0) ? (
        <p className="mt-3 text-[12px] text-slate-400">
          I am now showing zero active group rules in this table. Use suggested actions to add automation.
        </p>
      ) : null}
    </div>
  );
}
